import posthog from "posthog-js";

export const PURCHASER_API_BASE_URL = import.meta.env["VITE_PURCHASER_API_BASE_URL"];

export const getHeaders = () => {
    const sessionId = posthog.get_session_id();
    return {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        // Shorthand to add the session ID if it exists
        // This is to ensure that the backend can send the session ID to PostHog for API events
        ...(sessionId && { "X-POSTHOG-SESSION-ID": sessionId }),
    };
};
